import { z } from 'zod/v4';

export const leadTimeValidator = z
  .number({
    error: 'Lead time must be a number',
  })
  .int('Lead time must be an integer')
  .gt(0, 'Lead time must be greater than 0');
